import { PartnerBucketGroupPrice } from "../../../interfaces/partnerDeal.interface";

// A range bucket stored with no usable rate is "not priced here", so it falls
// through to the partner-level section rather than shadowing it. Same three
// conditions the backend resolver applies, so both agree on what counts as priced.
export const pricedOrUndefined = (
  price?: PartnerBucketGroupPrice
): PartnerBucketGroupPrice | undefined =>
  typeof price?.value === "number" &&
  Number.isFinite(price.value) &&
  (price.valueType === "Fixed" || price.valueType === "Percentage")
    ? price
    : undefined;
